import { render, staticRenderFns } from "./CancellationPolicyLinkSystemPolicy.vue?vue&type=template&id=50ff1600&scoped=true&"
import script from "./CancellationPolicyLinkSystemPolicy.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicyLinkSystemPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff1600",
  null
  
)

export default component.exports